<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-3">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Customer Groups</h4>
						<p class="card-category"></p>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-md-9">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Customer Search Add Customers to Groups</mat-label>
									<input type="text" matInput [formControl]="search" (input)="customerSearch()">
								</mat-form-field>
							</div>
							<div class="col-md-3 text-right">
								<button class="btn btn-success btn-sm mt-2" (click)="exportXls()" *ngIf="customergroups.length && !exporting">
									<i class="fa fa-file-excel-o"></i> XLS
								</button>
								&nbsp;
								<button class="btn btn-danger btn-sm mt-2" (click)="exportPdf()" *ngIf="customergroups.length && !exporting">
									<i class="fa fa-file-pdf-o"></i> PDF
								</button>
								<span *ngIf="exporting">
									<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
										<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
									</svg>
								</span>
							</div>
						</div>
						<ng-container *ngIf="searchResults">
							<div class="row" *ngFor="let c of searchResults">
								<div class="col-12" (click)="addCustomer(c)">
									{{ c.debtorno }}.{{c.branchcode}} {{ c.name }}
								</div>
								<mat-divider></mat-divider>
							</div>
						</ng-container>
						<ng-container *ngIf="grouped.length">
							<form [formGroup]="groupForm">
								<div class="card">
									<div class="card-body">
										<div class="row">
											<div class="col-8">
												<mat-form-field appearance="outline">
													<mat-label>Group Name</mat-label>
													<input type="text" class="text-left " matInput formControlName="group_name" />
												</mat-form-field>
											</div>
											<div class="col-4">
												<button mat-stroked-button color="success" aria-label="" (click)="addGroup()" class="mt-2 mb-2">
													<mat-icon>add</mat-icon> Add Group
												</button>
											</div>
										</div>

										<div class="row">
											<div class="col-6" *ngFor="let c of grouped">
												<button mat-stroked-button color="success" aria-label="" (click)="removeCustomer(c)" class="mt-2 mb-2">
													<mat-icon>remove</mat-icon>
												</button>
												{{ c.debtorno }}.{{c.branchcode}} {{ c.name }}
											</div>
											<mat-divider></mat-divider>
										</div>

									</div>
								</div>
							</form>
						</ng-container>
						<div class="row border-top" *ngFor="let c of customergroups">
							<div class="col-10">
								<h4>{{ c.group_name }}</h4>
							</div>
							<div class="col-2">
								<button mat-stroked-button color="success" aria-label="" (click)="removeGroup(c)" class="mt-2 mb-2">
									<mat-icon>remove</mat-icon>
								</button>
								<button mat-stroked-button color="success" aria-label="" (click)="editGroup(c)" class="mt-2 mb-2">
									<mat-icon>edit</mat-icon>
								</button>
							</div>
							<div class="col-12" *ngFor="let p of c.members">
								<button mat-stroked-button color="success" aria-label="" (click)="removeMember(p , c)" class="mt-2 mb-2">
									<mat-icon>remove</mat-icon>
								</button>
								{{ p.debtorno }}.{{ p.branchcode }} {{ p.name }}

							</div>
							<mat-divider></mat-divider>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>